// Sprout & Paws — autoplay product gallery videos when scrolled into view.
// Videos load via Dawn's DeferredMedia (click-to-play by default); this observes
// each gallery <deferred-media>, loads + plays it (muted, looped) at >=50%
// visibility and pauses it when scrolled away. Muted is required for mobile
// autoplay policies. DeferredMedia.loadContent() calls pauseAllMedia(), so after
// any load we re-play every video still in view.
(function () {
  function init() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var items = gallery.querySelectorAll('deferred-media');
    if (!items.length || !('IntersectionObserver' in window)) return;

    var inView = new Set();

    function prepAndPlay(dm) {
      var video = dm.querySelector('video');
      if (!video) return;
      video.muted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.loop = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var loadedSomething = false;
        entries.forEach(function (entry) {
          var dm = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            inView.add(dm);
            if (!dm.getAttribute('loaded') && typeof dm.loadContent === 'function') {
              dm.loadContent(false);
              loadedSomething = true;
            }
            prepAndPlay(dm);
          } else {
            inView.delete(dm);
            var video = dm.querySelector('video');
            if (video && !video.paused) video.pause();
          }
        });
        // loadContent() pauses ALL media — resume the ones still on screen
        if (loadedSomething) inView.forEach(prepAndPlay);
      },
      { threshold: [0, 0.5] }
    );

    items.forEach(function (dm) {
      observer.observe(dm);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
